{
    "TITLE": "Portal de Métodos de Verificación X",
    "WELCOME": "Bienvenido",
    "PASSWORD": "Contraseña",
    "LOGIN": "Iniciar Sesión",
    "LANGUAGE": "Idioma",
    "DASHBOARD": "Tablero de Solicitudes",
    "USER": "Usuario",
    "LOGOUT": "Cerrar sesión",
    "MENU": "Menú",
    "FILTER": "Filtro",
    "SIESPNUMBER": "# SIESPX",
    "TYPE": "Tipo",
    "NAME": "Nombre(s)",
    "FIRSTLASTNAME": "Primer Apellido",
    "SECONDLASTNAME": "Segundo Apellido",
    "STATUS": "Estatus",
    "STARTOFRESEARCH": "Inicio de Investigación",
    "RESULT": "Resultado",
    "NEWREQUEST": "Nueva Solicitud",
    "CREATEREQUEST": "Crear Solicitud",
    "BACK": "Atrás",
    "MAINPERSON": "Datos del Titular",
    "REFERENCES": "Referencias",
    "OTHERRELATIVES": "Otros Familiares",
    "JOBS": "Empleos",
    "GENERALINFORMATION": "Información General",
    "DIVISION": "División",
    "REQUIREDFIELD": "Campo Requerido",
    "LASTNAME": "Apellido",
    "ADDRESS": "Domicilio",
    "COUNTRY": "País",
    "STATE": "Estado",
    "CITY": "Ciudad",
    "STREET": "Calle",
    "POSTALCODE": "Código Postal",
    "BIRTHDATA": "Datos de Nacimiento",
    "BIRTHCOUNTRY": "País de Nacimiento",
    "BIRTHSTATE": "Estado de Nacimiento",
    "BIRTHCITY": "Ciudad de Nacimiento",
    "BIRTHDATE": "Fecha de Nacimiento",
    "RELATIVES": "Familiares",
    "FATHER": "Padre",
    "OCCUPATION": "Ocupación",
    "MOTHER": "Madre",
    "UNKNOWN": "Desconocido",
    "CANDIDATETYPE": "Tipo de Candidato",
    "SELECTCANDIDATETYPE": "Selecciona el tipo de candidato",
    "CANCEL": "Cancelar",
    "CONTINUE": "Continuar",
    "ADDRELATIVE": "Agregar Familiar",
    "SEARCHINTABLE": "Buscar en tabla",
    "ACTIONS": "Acciones",
    "ADDJOB": "Agregar Empleo",
    "COMPANY": "Empresa",
    "POSITION": "Puesto",
    "STARTDATE": "Fecha de Inicio",
    "ENDDATE": "Fecha de Terminación",
    "ISACTIVE": "¿Está Actualmente?",
    "AGE": "Edad",
    "ADDREFERENCE": "Agregar Referencia",
    "MARITALSTATUS": "Estado Civil",
    "NATIONALIDENTITYTYPE": "Tipo de Identificación Nacional",
    "NATIONALID": "Id Nacional",
    "NUMBER": "Número",
    "COLOGNE": "Colonia",
    "NOTES": "Notas",
    "SAVE": "Guardar",
    "SELECTOPTION": "Selecciona una opción",
    "GENDER": "Género",
    "TAXNUMBERTYPE": "Tipo de Número Fiscal",
    "TAXID": "Número Fiscal",
    "ENTERTAXID": "Ingresa el número fiscal",
    "SOCIALTYPEID": "Tipo de Seguridad Social",
    "SOCIALID": "Número de Seguridad Social",
    "ENTERSOCIALID": "Ingresa el número de seguridad social",
    "ENTERNAME": "Ingresa el nombre",
    "ENTERFIRSTLASTNAME": "Ingresa el primer apellido",
    "ENTERSECONDLASTNAME": "Ingresa el segundo apellido",
    "ENTERBIRTHDATE": "Ingresa la fecha de nacimiento",
    "ENTERCOMMENT": "Ingresa un comentario",
    "COMMENTS": "Comentarios",
    "ENTERNATIONALID": "Ingresa número de identificación nacional",
    "ENTERSTREET": "Ingresa la calle",
    "ENTERINTNUMBER": "Ingresa el número interior",
    "ENTEREXTNUMBER": "Ingresa el número exterior",
    "ENTERSUBLOCALITY": "Ingresa la colonia",
    "ENTERPOSTALCODE": "Ingresa el código postal",
    "INTNUMBER": "Número Interior",
    "EXTNUMBER": "Número Exterior",
    "SPOUSE": "Cónyuge",
    "RELATIVE": "Familiar",
    "SCHOOLING": "Último Grado de Estudios",
    "PROFESSION": "Profesión",
    "ENTERPROFESSION": "Ingresa la profesión",
    "RELATIVETYPE": "Tipo de Familiar",
    "ADD": "Agregar",
    "EDIT": "Editar",
    "CONFIRMATION": "Confirmación",
    "SECURITY": "Seguridad",
    "PLEASEENTERSECURITYCODE": "Por favor, ingresa el código de autenticación enviado a tu dispositivo.",
    "MFACODE": "Código MFA",
    "VALIDATE": "Validar",
    "EDITRELATIVE": "Editar Familiar",
    "EDITJOB": "Editar Empleo",
    "ENTERCOMPANYNAME": "Ingresa el nombre de la compañía",
    "ENTERPOSITIONNAME": "Ingresa el nombre del puesto",
    "ENTERSTARTDATE": "Ingresa la fecha de inicio",
    "ENTERENDDATE": "Ingresa la fecha de fin",
    "ENTERAGE": "Ingresa la edad",
    "EDITREFERENCE": "Editar Referencia",
    "DELETE": "Eliminar",
    "PROGRESS": "Progreso",
    "LOADING": "Cargando",
    "SENDTOSIES": "Enviar a SIES",
    "COMPLETEDPROGRESS": "Progreso completado",
    "SENT": "En Investigación",
    "EXPIRATIONDATE": "Fecha de Expiración",
    "SEEREQUEST": "Ver solicitud",
    "SEND": "Enviar",
    "COMPLETED": "Completado",
    "SEERESULT": "Ver resultado",
    "SEMAPHORE": "Semáforo",
    "REQUEST": "Solicitud",
    "CLOSE": "Cerrar",
    "REPORTS": "Reportes",
    "DOWNLOADREPORT": "Descargar Reporte",
    "SELECTDATESRANGE": "Seleccione Rango de Fechas",
    "NODATAMATCHING": "No hay datos que coincidan con el filtro",
    "DOWNLOADPROCESSEDREQUESTREPORT": "Descargar reporte de solicitudes procesadas",
    "EVIDENCES": "Evidencias",
    "RESUBMIT": "Reenviar",
    "SELECTALL": "Seleccionar todo",
    "DOWNLOADRESULT": "Descargar Resultado",
    "RESEARCHMENTRESULT": "Resultado de Investigación",
    "IMAGEVIEWER": "Visor de Imagen",
    "VIEWIMAGE": "Ver Imagen",
    "FOCUSREQUIREDFIELDS": "Enfocar campos faltantes",

    "_AMcomment": "From here, there are data base values ^_~",

    "Operativo": "Operativo",
    "Administrativo": "Administrativo",
    "INCOMPLETE": "Incompleto",
    "READY": "Listo para enviar"
}
  